/**
 * A bout length as an operator reads and types it: «1:30», «2:00».
 *
 * The API holds whole seconds (BoutDurationController); people think in
 * minutes and seconds, and «90» on a screen next to «2:00» on the paper
 * protocol is a conversion somebody gets wrong at the table.
 */
export const formatBoutDuration = seconds => {
    if (null === seconds || undefined === seconds || '' === seconds) {
        return '';
    }

    const total = Number(seconds);
    const minutes = Math.floor(total / 60);
    const rest = total % 60;

    return minutes + ':' + String(rest).padStart(2, '0');
};

/**
 * «1:30» → 90, «2» → 120 (whole minutes), «1,5» / «1.5» → 90.
 * '' → null (inherit). Anything else → NaN, for the caller to refuse.
 */
export const parseBoutDuration = text => {
    const value = String(null === text || undefined === text ? '' : text).trim();
    if ('' === value) {
        return null;
    }

    const clock = value.match(/^(\d{1,2}):(\d{2})$/);
    if (clock) {
        const seconds = Number(clock[2]);

        return seconds < 60 ? Number(clock[1]) * 60 + seconds : NaN;
    }

    const minutes = value.replace(',', '.');
    if (/^\d+(\.\d+)?$/.test(minutes)) {
        return Math.round(Number(minutes) * 60);
    }

    return NaN;
};
